import { Injectable } from '@angular/core';

@Injectable()
export class AtxBreadcrumbService {
    public getNavigationAfterRedirect(navigation, initLabel) {
        let path = '';

        const [pathname] = navigation.url.split('?');

        return pathname.split('/').map((label) => {
            path += `/${ label }`;

            return { path, label: label || initLabel };
        });
    }
}
